import React from "react";
import Footer from "../../components/Footer";

class FooterContainer extends React.Component {

    render() {
        return (
            <div>
                <Footer/>
            </div>
        )
    }
}

export default FooterContainer;